import {useState} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { format, parseISO } from 'date-fns';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import { useSessionContext } from '../../../contexts/SessionContext';


function handleClick(e){

}

export default function LoadListListItemProduct(props){
    //console.debug("RTS Break LoadListListItemProductDetail");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();
    
    return (
        props.data.curAliasName == null
        ?
            <>
            <Typography variant="h6" sx={{color:"Red"}}>No Product Information Available</Typography>
            </> 
        :
            <>
            <Stack>
                <>
                <Tooltip title={props.data.curProductIdSap}>
                    
                    <Typography variant="h6" >
                        {props.data.curAliasName}
                    </Typography>
                </Tooltip>
                <Typography variant="caption" >
                    {props.data.curAliasNumber}
                </Typography>
                </>                                    
            </Stack>
            </>
    );   
}

